export const images = {
    fbIcon: require('./fb-icon.png'),
    instaIcon: require('./insta-icon.png'),
    pricing: require('./pricing.jpg'),
    leftArrow: require('./left-arrow.png'),
    main_logo:  require('./main-logo.png'),
    banner02: require('./banner02.jpg'),
    banner03: require('./banner03.jpeg'),
    nail01: require('./nail1.jpg'),
    nail02: require('./nail2.jpg'),
    nail03: require('./nail3.jpg'),
    nail04: require('./nail4.jpg'),
    nail05: require('./nail5.jpg'),
    nail06: require('./nail6.jpg'),
    nail_shop4: require('./nail_shop4.jpg'),
    popup: require('./popup.jpg')
};
